module.exports = __webpack_public_path__ + "static/media/05.249846a3.jpg";